import React from "react";
import BaseIcon from "../../ui/BaseIcon.jsx";
import { mdiRefresh } from "@mdi/js";

/**
 * Consistent footer for every catalog section.
 * Shows inline error, and Recargar / Descartar / Guardar buttons.
 */
export default function SectionFooter({
  dirty,
  saving,
  loading,
  error,
  onSave,
  onDiscard,
  onReload,
}) {
  return (
    <div className="section-footer">
      {error && <div className="section-error">{error}</div>}
      <div className="section-footer-actions">
        <button
          className="button-icon section-reload-btn"
          onClick={onReload}
          disabled={loading || saving}
          title="Recargar desde el servidor"
        >
          <BaseIcon path={mdiRefresh} size={16} className={loading ? "animate-spin" : ""} />
        </button>
        <button
          className="button-secondary"
          onClick={onDiscard}
          disabled={!dirty || saving}
        >
          Descartar
        </button>
        <button
          className="button-primary"
          onClick={onSave}
          disabled={saving || loading}
        >
          {saving ? "Guardando…" : "Guardar"}
        </button>
      </div>
    </div>
  );
}
